(function handlerOnPageForm() {
  'use strict';

  const fillInputsOnPageForm = (event) => {
    const formData = event.detail;
    if (formData.name) {
      const name = document.querySelector('#Name');
      if (name) {
        name.value = formData.name;
      }
    }
    if (formData.emailAddress) {
      const emailAddress = document.querySelector('#MailAddress');
      if (emailAddress) {
        emailAddress.value = formData.emailAddress;
      }
    }
    if (formData.phoneNumber) {
      const phoneNumber = document.querySelector('#UserPhoneNumber');
      if (phoneNumber) {
        phoneNumber.value = formData.phoneNumber;
      }
    }
    if (formData.postalCode) {
      const postalCode = document.querySelector('#UserPostalCode');
      if (postalCode) {
        postalCode.value = formData.postalCode;
      }
    }
    if (formData.livesOutside != null)
    {
      const livesOutside = document.querySelector('#lives-outside');
      if (livesOutside) {
        livesOutside.checked = formData.livesOutside;
      }
      const postalCode = document.querySelector('#UserPostalCode');
      if (postalCode) {
        if (formData.livesOutside) {
          postalCode.value = '';
        }
        postalCode.disabled = formData.livesOutside;
      }
    }
    if (formData.preferredContactMethod) {
      const contactMethod = document.querySelector('#nhs-contact-method');
      if (contactMethod) {
        contactMethod.value = formData.preferredContactMethod;
      }
    }
    if (formData.realtorQuestionAnswer) {
      const realtorAnswer = document.querySelector('#nhs-real-agent');
      if (realtorAnswer) {
        realtorAnswer.value = formData.realtorQuestionAnswer;
      }
    }
    if (formData.sendAlerts != null) {
      const sendAlerts = document.querySelector('#SendAlerts');
      if (sendAlerts) {
        sendAlerts.checked = formData.sendAlerts;
      }
    }
  };

  document.body.addEventListener('onLeadPosted', fillInputsOnPageForm);
}());
